import React from 'react';
import { Drawer, Typography, Space, List, Button } from 'antd';
import slidesIcon from '../../../../assets/DasboardIcons/slides.svg';
import boardIcon from '../../../../assets/DasboardIcons/board.png';
import mindmapIcon2 from '../../../../assets/DasboardIcons/ideation.svg';
import GridIcon from '../../../../assets/DasboardIcons/grid.png';
import spacesIcon from '../../../../assets/DasboardIcons/spaces.svg';
import padIcon from '../../../../assets/DasboardIcons/pad.png';
import WorkWiseIcon from '../../../ResultComponent/WorkWsieIcon';
import styles from '../../Dashboard.module.css';

const ApplicationsDrawer = ({ open, onClose }) => {


  const appUrls = {
    grid: 'https://grid.workw.com/',
    pad: 'https://pad.workw.com/',
    slides: 'https://slides.workw.com/',
    board: 'https://board.workw.com/',
    mindmap: 'https://map.workw.com/',
    ideation: 'https://ideation.workw.com/',
    spaces: 'https://spaces.workw.com/',
  };

  const handleAppClick = (id) => {
    const url = appUrls[id];
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const customTitle = (
    <Space align="center" size={8}>
      <WorkWiseIcon width="80" height="40" logoOnly={false} textColor='#000' />
      <Typography.Text className={styles['applications-drawer-title-text']}>
        MindMap
      </Typography.Text>
    </Space>
  );

  const items = [
    { id: 'pad', name: 'Pad', icon: padIcon },
    { id: 'slides', name: 'Slides', icon: slidesIcon },
    { id: 'grid', name: 'Grid', icon: GridIcon },
    { id: 'board', name: 'Board', icon: boardIcon },
    { id: 'ideation', name: 'Ideation', icon: mindmapIcon2 },
    { id: 'spaces', name: 'Spaces', icon: spacesIcon },
  ];

  return (
    <Drawer
      title={customTitle}
      placement="left"
      onClose={onClose}
      open={open}
      closable={false}
      width={300}
      styles={{
        body: { padding: 16, background: 'white' },
        header: { borderBottom: '1px solid #f0f0f0', paddingLeft: '10px' }
      }}
      zIndex={1050}
      mask={true}
      style={{ position: 'absolute' }}
    >
      <Space direction="vertical" size="middle" style={{ display: 'flex', width: '100%' }}>
        <List
          dataSource={items}
          split
          renderItem={(item) => (
            <List.Item className={styles['applications-drawer-list-item']}>
              <Button
                key={item.id}
                type="text"
                block
                onClick={() => handleAppClick(item.id)}
                className={styles['applications-drawer-button']}
              >
                <img src={item.icon} alt={item.name} className={styles['applications-drawer-icon']} />
                <Typography.Text className={styles['applications-drawer-text']}>{item.name}</Typography.Text>
              </Button>
            </List.Item>
          )}
        />
      </Space>
    </Drawer>
  );
};

export default ApplicationsDrawer;